<p>
  <mat-icon>{{ icon }}</mat-icon>
  <span class="text">{{ messageToDisplay }}</span>
</p>
